import { createContext, Dispatch, SetStateAction, useContext, useState, PropsWithChildren } from 'react';

export type TabsContextProps = {
  currentIndex: number,
  setCurrentIndex: Dispatch<SetStateAction<number>>,
  isInit: boolean
};

export const TabsContext = createContext<TabsContextProps>({
  currentIndex: 0,
  setCurrentIndex: () => {},
  isInit: false
});

export type TabsProviderProps = {
  index?: number 
} & PropsWithChildren


export const TabsProvider = ({ children, index = 0}: TabsProviderProps) => {
  const [currentIndex, setCurrentIndex] = useState(index)
  const [isInit, setIsInit] = useState<boolean>(false)

  if (!isInit && currentIndex !== index) {
    setIsInit(true)
  }

  return (
    <TabsContext value={{ currentIndex, setCurrentIndex, isInit }}>
      {children}
    </TabsContext>
  );
}

export function useTabsContext(): TabsContextProps {
  const context = useContext(TabsContext);
  if (context === undefined) {
    throw new Error('useTabs must be used within a TabsProvider');
  }
  return context;
}